import client from './rest/AdminClient';
import AdminServerActionCreators from '../actions/AdminServerActionCreators';
const deleteCols = (_id) => {
    client({
        method: 'DELETE',
        path: '/api/columns',
        entity: JSON.stringify({ _id }),
    })
        .then((result) => {
        const { entity } = result;
        AdminServerActionCreators.deleteColumnSet(entity);
    })
        .catch((e) => {
        AdminServerActionCreators.errorColumnSet(e);
    });
};
const getCols = () => {
    client({
        method: 'GET',
        path: '/api/columns',
    })
        .then((result) => {
        const { entity } = result;
        AdminServerActionCreators.getColumnSet(entity);
    })
        .catch((e) => {
        AdminServerActionCreators.errorColumnSet(e);
    });
};
const updateCols = (data) => {
    const { _id, cols } = data;
    if (cols.length > 0 && _id) {
        client({
            method: 'PUT',
            path: '/api/columns',
            entity: JSON.stringify(data),
        })
            .then((result) => {
            AdminServerActionCreators.updateColumnSet(result.entity);
        })
            .catch((e) => {
            AdminServerActionCreators.errorColumnSet(e);
        });
    }
    return 'error';
};
const createCols = (data) => {
    const { filter_id, cols } = data;
    if (cols.length > 0 && filter_id) {
        client({
            method: 'POST',
            path: '/api/columns',
            entity: JSON.stringify(data),
        })
            .then((result) => {
            AdminServerActionCreators.createColumnSet(result.entity);
        })
            .catch((e) => {
            AdminServerActionCreators.errorColumnSet(e);
        });
    }
    return 'error';
};
export default {
    getCols() {
        getCols();
    },
    updateCols(data) {
        updateCols(data);
    },
    deleteCols(data) {
        deleteCols(data);
    },
    createCols(data) {
        createCols(data);
    },
};
